(function () {
  var COMPANY_ID = window.__bisCompanyId;
  var API_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID;

  var overlay = document.getElementById('bis-card-overlay');
  var form = document.getElementById('bis-card-form');
  var emailInput = document.getElementById('bis-card-email');
  var variantSelect = document.getElementById('bis-card-variants');
  var productTitle = document.getElementById('bis-card-product-title');
  var successMsg = document.getElementById('bis-card-success');
  var errorMsg = document.getElementById('bis-card-error');
  var submitBtn = document.getElementById('bis-card-submit');

  function openModal(btn) {
    var variants = [];
    try { variants = JSON.parse(btn.dataset.variants || '[]'); } catch (e) {}
    var title = btn.dataset.productTitle || '';

    variantSelect.innerHTML = '';
    variants.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = v.id;
      opt.textContent = v.title;
      variantSelect.appendChild(opt);
    });

    productTitle.textContent = title;
    emailInput.value = '';
    form.style.display = '';
    successMsg.style.display = 'none';
    errorMsg.style.display = 'none';
    overlay.style.display = 'flex';
    emailInput.focus();
  }

  function closeModal() {
    overlay.style.display = 'none';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.btn-notify-when-available[data-variants]');
    if (btn) {
      e.preventDefault();
      openModal(btn);
      return;
    }
    if (e.target === overlay || e.target.closest('#bis-card-close')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.style.display === 'flex') closeModal();
  });

  function setFieldError(el, hasError) {
    el.classList.toggle('bis-card-modal__field--error', hasError);
  }

  variantSelect.addEventListener('change', function () { setFieldError(variantSelect, false); });
  emailInput.addEventListener('input', function () { setFieldError(emailInput, false); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = emailInput.value.trim();
    var variantId = variantSelect.value;
    var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    var variantValid = !!variantId;

    setFieldError(variantSelect, !variantValid);
    setFieldError(emailInput, !emailValid);

    if (!variantValid || !emailValid) return;

    submitBtn.disabled = true;

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId },
            },
          },
        },
      }),
    })
      .then(function (res) {
        submitBtn.disabled = false;
        if (res.ok || res.status === 202) {
          form.style.display = 'none';
          successMsg.style.display = '';
        } else {
          return res.json().then(function (body) {
            throw new Error((body.errors && body.errors[0] && body.errors[0].detail) || ('Status ' + res.status));
          });
        }
      })
      .catch(function (err) {
        submitBtn.disabled = false;
        errorMsg.textContent = err.message || 'Something went wrong. Please try again.';
        errorMsg.style.display = '';
      });
  });
})();
